import {IntermediatePart} from "../../intermediatePart";
import Appliance from "../../parts/appliance";
import {LayoutAbbreviations, useOldCabinetLogic} from "../../constants";
import CountertopGroup from "../../parts/countertopGroup";

export default class TallCabinet extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'tall_cabinet';
    this.partName = 'Tall Cabinet';
    this.translateId = "visualizer.kitchen.cabinet.tall_cabinet";
    this.canBeDisabled = false;
    this.hasAdditionalParts = true;
    this.layerPriority = 1;
    this.allWallsCanBeApplied = true;
    if (isChild) {
      this.nextFeaturesPageToLoadArray = {};
      LayoutAbbreviations.forEach(layoutAbbreviation => {
        this.nextFeaturesPageToLoadArray[layoutAbbreviation] = {
          page: 0,
          allReceived: false,
        };
      });
    }
  }

  load(dbFeature) {
    const partNumber = (dbFeature.metaData["Part"] && +dbFeature.metaData["Part"][0]) === 1 ? 1 : 2;
    return super.load_(dbFeature, new TallCabinet(false, partNumber), true, partNumber === 1 ? 'features' : 'featuresParts');
  }

  disabledClick() {
    this.activeFeatureParts.forEach((activeFeaturePart) => {
      activeFeaturePart.disabled = this.disabled
    });
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    if (useOldCabinetLogic) {
      return conditions
    }
    const cabinetParent = this.getParent();
    const countertopParent = cabinetParent.layout.parts[CountertopGroup.id];
    // const applianceParent = cabinetParent.layout.parts[Appliance.id];
    const sinkIsVisible = countertopParent && countertopParent.sink && countertopParent.sink.activeFeature && !countertopParent.sink.disabled;
    if (sinkIsVisible) {
      conditions.push({
        propName: "MountType",
        propValue: countertopParent.sink.activeFeature.metaData["MountType"]
      });
    }
    return conditions
  }

  getActiveFeatureConditions() {
    return this.getArrayOfConditions().filter(metaObject => {
      return metaObject.propName !== "MountType"
    })
  }

  getActiveFeaturePartsAccordingToActiveFeature(fromFeature = this.activeFeature, activeFeatureConditions = []) {
    let activeFeatureParts = [];
    if (fromFeature && fromFeature.partNumber) {
      const name1 = fromFeature.getSplittedFeatureName();
      // console.log("name1", name1);
      let arrayOfConditions = activeFeatureConditions.length
        ? activeFeatureConditions
        : this.getActiveFeatureConditions(fromFeature);

      const cabinetParent = this.getParent();
      const countertopParent = cabinetParent.layout.parts[CountertopGroup.id];
      const applianceParent = cabinetParent.layout.parts[Appliance.id];
      const sink = countertopParent.sink;

      //part 1 will be with MountType
      // part 2 dishwasher - depends on dishwasher metaData Width
      //part 3 depends on stove metaData Width
      // part 4 - fridge
      // part 5 - peninsula

      const withStoveConditions = [...arrayOfConditions, {
        propName: "Width",
        propValue: applianceParent && applianceParent.stove && applianceParent.stove.activeFeature
        && applianceParent.stove.activeFeature.metaData["Width"]
          ? applianceParent.stove.activeFeature.metaData["Width"]
          : "30",
      }];
      const withDishWasherConditions = [...arrayOfConditions, {
        propName: "Width",
        propValue: applianceParent && applianceParent.dishwasher && applianceParent.dishwasher.activeFeature
        && applianceParent.dishwasher.activeFeature.metaData["Width"]
          ? applianceParent.dishwasher.activeFeature.metaData["Width"]
          : "24",
      }];
      const withFridgeConditions = [...arrayOfConditions, {
        propName: "Width",
        propValue: applianceParent && applianceParent.fridge && applianceParent.fridge.activeFeature
        && applianceParent.fridge.activeFeature.metaData["Width"]
          ? applianceParent.fridge.activeFeature.metaData["Width"]
          : "36",
      }];
      activeFeatureParts = this.featuresParts.filter((feature) => {
        if (useOldCabinetLogic) {
          if (feature.metaData["Part"] && feature.metaData["Part"].includes("2")
            && sink && !sink.disabled && sink.activeFeature) {
            return name1 === feature.getSplittedFeatureName() && feature.matchesMetaForArrayOfConditions([
              ...arrayOfConditions,
              {propName: "MountType", propValue: sink.activeFeature.metaData["MountType"]}
            ])
          }
          if (feature.metaData["Part"] && feature.metaData["Part"].includes("3")
            && applianceParent && applianceParent.dishwasher && !applianceParent.dishwasher.disabled && applianceParent.dishwasher.activeFeature) {
            return false
          }
          if (feature.metaData["Part"] && feature.metaData["Part"].includes("4")
            && applianceParent && applianceParent.stove && !applianceParent.stove.disabled && applianceParent.stove.activeFeature) {
            return false
          }
          if (feature.metaData["Part"] && feature.metaData["Part"].includes("6")) { // 6 is fridge related
            if (!applianceParent || !applianceParent.fridge || applianceParent.fridge.disabled || !applianceParent.fridge.activeFeature) {
              return false
            }
            const fridgeConditions = applianceParent.fridge.getFridgeWidthAndHeightConditions();
            return name1 === feature.getSplittedFeatureName() && feature.matchesMetaForArrayOfConditions([...arrayOfConditions, ...fridgeConditions])
          }
        } else {
          if (name1 !== feature.getSplittedFeatureName()) {
            return false
          }
          if (feature.metaData["Part"] && feature.metaData["Part"].includes("2")) {
            return feature.matchesMetaForArrayOfConditions(withDishWasherConditions)
          }
          if (feature.metaData["Part"] && feature.metaData["Part"].includes("3")) {
            return feature.matchesMetaForArrayOfConditions(withStoveConditions)
          }
          if (feature.metaData["Part"] && feature.metaData["Part"].includes("4")) {
            return feature.matchesMetaForArrayOfConditions(withFridgeConditions)
          }
          if (feature.metaData["Part"] && feature.metaData["Part"].includes("5")) {
            if (!applianceParent || !applianceParent.oven || applianceParent.oven.disabled || !applianceParent.oven.activeFeature) {
              return false
            }
          }
          return feature.matchesMetaForArrayOfConditions(arrayOfConditions)
        }

        return name1 === feature.getSplittedFeatureName() && feature.matchesMetaForArrayOfConditions(arrayOfConditions)
      });

      // console.log("this.featuresParts", this.featuresParts);
      // console.log("activeFeatureParts", activeFeatureParts);
      activeFeatureParts.forEach((activeFeaturePart) => {
        activeFeaturePart.disabled = this.disabled
      });
    }
    return activeFeatureParts
  }


}

